import { render, staticRenderFns } from "./JcdcBreadcrumbsVue.vue?vue&type=template&id=465b736d"
import script from "./JcdcBreadcrumbsVue.vue?vue&type=script&lang=ts"
export * from "./JcdcBreadcrumbsVue.vue?vue&type=script&lang=ts"
import style0 from "./JcdcBreadcrumbsVue.vue?vue&type=style&index=0&id=465b736d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports